import { baseApi } from "./baseApi";

interface PasswordApiResponse {
  success: boolean;
  message: string;
  data: unknown;
  errors: string[];
}

export const passwordApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    changeAdminPassword: builder.mutation<
      PasswordApiResponse,
      { currentPassword: string; newPassword: string }
    >({
      query: (payload) => ({
        url: "/Admin/change-password",
        method: "PUT",
        body: payload,
      }),
    }),

    resetEmployeePassword: builder.mutation<
      PasswordApiResponse,
      { id: number; newPassword: string }
    >({
      query: ({ id, newPassword }) => ({
        url: `/Employee/${id}/reset-password`,
        method: "PUT",
        body: { newPassword },
      }),
    }),

    resetClientPassword: builder.mutation<
      PasswordApiResponse,
      { id: string; newPassword: string }
    >({
      query: ({ id, newPassword }) => ({
        url: `/Client/${id}/password`,
        method: "PUT",
        body: { newPassword },
      }),
    }),
  }),
});

export const {
  useChangeAdminPasswordMutation,
  useResetEmployeePasswordMutation,
  useResetClientPasswordMutation,
} = passwordApi;
